// 颜色表
export const HISTORY_COLOR_LIST = [
    '#B30000', '#E6118F', '#F1633A', '#3646A0', // new 12
    '#3184E9', '#09A9B9', '#822F1D', '#C67600',
    '#FFB400', '#0D6C54', '#918B3D', '#7BB725',
] as const;

export const HISTORY_MODULE_NAME = 'history';

export const NOHISTORY_HEATCODE = 13025; // 查询文档修订记录时满足热度管控返回错误码

/**
 * @deprecated 这个可以去掉了
 */
export const RecordTypeKey = {
    DEFAULT: 'default',
    HISTORY_VERSION: 'history-version',
};
